import React from 'react';
import { useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';

import { formatOnlineCourseSubtitle } from '../../../../helpers/content';
import Card from '../../../Card';
import type { SearchAllContentOnlineCourseHit } from '../../types';

// eslint-disable-next-line max-len
const SearchAllContentResultsOnlineCourseHit: React.FC<{ hit: SearchAllContentOnlineCourseHit }> = ({ hit }) => {
  const { t } = useTranslation();

  return (
    <Card
      className="SearchAllContent__Results__hit"
      url={hit.url[0]}
      label={t(`content_types.${hit.type[0]}.type`)}
      labelIcon="menu_book"
      sublabel={hit.is_infontd_course?.[0] ? t(`content_types.${hit.type[0]}.is_infontd_course`) : undefined}
      title={<Highlight attribute="title" hit={hit} />}
      subtitle={formatOnlineCourseSubtitle(
        hit.name,
        hit.bibcite_publisher?.[0],
        hit.date?.[0],
        hit.languages,
      )}
    />
  );
};

export default SearchAllContentResultsOnlineCourseHit;
